<template>
  <div class="start-wrap" :class="{'hide': !isShow}">
    <img class="start start1" :src="start1" alt />
    <img class="start start2" :src="start2" alt />
    <img class="start start3" :src="start3" alt />
    <img class="start start4" :src="start4" alt />
    <img class="start start5" :src="start5" alt />
  </div>
</template>

<script>
var start1 = require("../../../assets/icon-start-1.png");
var start2 = require("../../../assets/icon-start-2.png");
var start3 = require("../../../assets/icon-start-3.png");
var start4 = require("../../../assets/icon-start-4.png");
var start5 = require("../../../assets/icon-start-5.png");

import $ from "jquery";

const StarEndPostions = [
  "translate3d(-42px, -28px, 0)", //1
  "translate3d(-42px, 13px, 0)", //2
  "translate3d(-14px, 35px, 0)", //3
  "translate3d(20px, 9px, 0)", //4
  "translate3d(10px, -30px, 0)" //5
];

export default {
  props: [],
  data() {
    return {
      isShow: false,
      start1,
      start2,
      start3,
      start4,
      start5,
      box: {
        top: 0,
        left: 0
      }
    };
  },
  methods: {
    hide(){
      console.log('hide...');
      this.isShow = false;
    },
    startAnimation(){
      console.log('start...');
      this.isShow = true;
      setTimeout(this.handleStart, 100);
    },
    getBoxPosition() {
      var boxTop = document.getElementById("box").getBoundingClientRect().top;
      var boxLeft = document.getElementById("box").getBoundingClientRect().left;
      this.box.top = boxTop;
      this.box.left = boxLeft;
    },
    handleStart() {
      this.getBoxPosition();
      setTimeout(() => {
        this.moveStar(4, 800);
        this.moveStar(5, 900);
        this.moveStar(3, 1000);
        this.moveStar(2, 1100);
        this.moveStar(1, 1200);
      }, 200);
    },
    // 星星移动顺序： 4 5 3 2 1
    moveStar(starIndex, time) {
      var screenWidth = $(window).width();
      var screenHeight = $(window).height();
      setTimeout(() => {
        var className = "start" + starIndex;
        var starWidth = $(`.${className}`).width();
        var starHeight = $(`.${className}`).height();

        var target = $(`.${className}`)
          .css({
            transform: StarEndPostions[starIndex - 1]
          })
          .removeClass(className);

        setTimeout(() => {
          var offsetLeft =
            this.box.left -
            screenWidth / 2 +
            $("#box").width() / 2 -
            starWidth / 2;
          var offsetTop =
            this.box.top -
            screenHeight / 2 +
            $("#box").height() / 2 -
            starHeight / 2;
          target.css({
            transform: `translate3d(${offsetLeft}px, ${offsetTop}px, 0px)`
          });
        }, 100);

        setTimeout(() => {
          target.hide();
        }, 500);
      }, time);

      if (starIndex == 4) {
        setTimeout(() => {
          this.showMask = false;
          this.showStart = false;

          this.hide();
          this.$emit('close');
        }, 1.8 * 1000);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../animation/animation.less";

.start-wrap{
  z-index: 9999;
  &.hide{
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Modal/Star.vue